<div style="display: flex;justify-content: center;">
    <div style="display:flex;flex-direction: column;">
        <div style="font-size:14px;color:#888;text-align: center;">Première connexion</div>
        <div style="font-size:14px;color:#888;font-weight: bold;text-align: center;">Modification de mot de passe</div>
        <br />
        <div style="font-size:12px;color:#888;">Le mot de passe doit faire au moins 12 caractères, contenir minuscules,
            majuscules, chiffres et caratères spéciaux</div>
        <br />
        <div *ngIf="changeError">
            <div  style="font-size:12px;color:rgb(220, 19, 19);font-weight: bold;text-align: center;">{{ errorMessage }}</div>
            <br />
        </div>
        <div>
            <mat-form-field class="large-width" style="width:100%;">
                <mat-label>Mot de passe</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" required [(ngModel)]="passwordInput" />
                <mat-icon style="cursor: default;" matSuffix (mousedown)="hide = false" (mouseup)="hide = true">{{hide ?
                    'visibility_off' : 'visibility'}}</mat-icon>
                <span *ngIf="shortPasswordError" class="error">
                    Le mot de passe doit faire 12 caractères minimum
                </span>
                <span *ngIf="strongPasswordError" class="error">
                    Le mot de passe doit contenir minuscule, majuscule, chiffre et caratère spécial
                </span>

            </mat-form-field>
        </div>
        <br />
        <div>
            <mat-form-field class="large-width" style="width:100%;">
                <mat-label>Confirmation mot de passe</mat-label>
                <input matInput [type]="hide ? 'password' : 'text'" required [(ngModel)]="password2Input" />
                <mat-icon style="cursor: default;" matSuffix (mousedown)="hide = false" (mouseup)="hide = true">{{hide ?
                    'visibility_off' : 'visibility'}}</mat-icon>

                <span *ngIf="samePasswordError" class="error">
                    Les mots de passe sont différents
                </span>
            </mat-form-field>
        </div>
        <div style="display: flex;justify-content: center;">
            <button mat-stroked-button (click)="sendNewPassword()">Valider</button>
        </div>
    </div>
</div>